<template>
    <tool-tip-error v-if="!valid"
                    text="too large"
                    type="total"/>
    <div :class="{ 'invalid-indicator' : !valid }" style="text-align:right;">
        <div>
            {{ unitTotal }} total units, or {{ packagingTotal }} (est.) total packagings
            <label v-if="dairy.showPrice" style="font-size:larger;font-weight:bold;padding-left:5%;">
                {{ orderPriceTotal }}
            </label>
        </div>
    </div>
</template>

<script>
import ToolTipError from '@/components/tooltip/TooltipError'

export default {
    name: 'OrderTotal',
    props: ['dairy', 'products', 'columns', 'min', 'max'],
    emits: ['hasunits', 'isvalid'],
    data: function () {
        return {
            valid: false,
        }
    },
    components: {
        ToolTipError,
    },
    computed: {
        unitTotal: function () {
            let totalUnits = 0

            for (const product of this.products) {
                if (product.packagings !== undefined && product.packagings > 0)
                    totalUnits += (parseInt(product.packagings) * parseInt(product.unitsPerPackaging))

                if (product.units !== undefined && product.units > 0)
                    totalUnits += parseInt(product.units)
            }

            return totalUnits
        },
        packagingTotal() {
            let totalPackagings = 0

            for (const product of this.products) {
                if (product.units !== undefined && product.units > 0)
                    totalPackagings += (parseInt(product.units) / parseInt(product.unitsPerPackaging))

                if (product.packagings !== undefined && product.packagings > 0)
                    totalPackagings += parseInt(product.packagings)
            }

            return totalPackagings.toFixed(2)
        },
        orderPriceTotal() {
            let totalOrderPrice = 0

            for (const product of this.products) {
                if (product.units !== undefined && product.units > 0)
                    totalOrderPrice += (parseInt(product.units) * parseFloat(product.pricePer))

                if (product.packagings !== undefined && product.packagings > 0)
                    totalOrderPrice += (parseInt(product.packagings) * parseFloat(product.pricePer))
            }

            return totalOrderPrice.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })
        }
    },
    watch: {
        unitTotal: {
            deep: true,
            handler: function (newVal) {
                this.valid = newVal >= this.min && newVal <= this.max
                this.$emit('hasunits', newVal > this.min)
                this.$emit('isvalid', newVal > this.min && newVal <= this.max)
            }
        }
    },
    mounted() {
        this.valid = true
    }
}
</script>
